/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Occupancy_LowInputs */

const fr_marker_occupancy_low = /** @type {(inputs: Marker_Occupancy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible affluence`)
};

const en_marker_occupancy_low = /** @type {(inputs: Marker_Occupancy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low occupancy`)
};

/**
* | output |
* | --- |
* | "Low occupancy" |
*
* @param {Marker_Occupancy_LowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_occupancy_low = /** @type {((inputs?: Marker_Occupancy_LowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Occupancy_LowInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_occupancy_low(inputs)
	return en_marker_occupancy_low(inputs)
});